import OrderList from '../components/Order/OrderList';
import { t } from '../i18n';

export default function OrderListPage() {
  return (
    <>
      <h2 className="text-2xl font-semibold mb-4 text-blue-600">{t('Нарачки')}</h2>
      <OrderList />
    </>
  );
}